import { useState } from 'react';

import { trackInfoModalShow } from '../tracking';

import type { TSlide } from '@cian/frontend-newbuilding-promo-modal-widget/es/components/SliderModal/types/slide';
import { useRuntimeSetting } from 'shared/hooks';

interface IResult {
  isInfoModalVisible: boolean;
  infoSlides: TSlide[] | null;
  openInfoModal(): void;
  closeInfoModal(): void;
}

export const useDiscountPromoInfo = (): IResult => {
  const [isVisible, setIsVisible] = useState(false);

  const infoSlides = useRuntimeSetting<TSlide[]>('discountPromoFilterInfo');

  const openInfoModal = () => {
    setIsVisible(true);

    trackInfoModalShow();
  };

  const closeInfoModal = () => {
    setIsVisible(false);
  };

  return {
    isInfoModalVisible: isVisible,
    infoSlides,
    openInfoModal,
    closeInfoModal,
  };
};
